import {connect} from "react-redux";
import {getBaseUrlSelector} from "../../../globalState/app/selectros";
import ObjectCard from "./ObjectCard";


let mapStateToProps = (state) => {
    return {
        baseUrl: getBaseUrlSelector(state),
    }
};

export default connect(mapStateToProps)(ObjectCard);


